// extracted by mini-css-extract-plugin
export default {"MarkdownPage":"markdown-page--MarkdownPage--37lA3","container":"markdown-page--container--1nXWM"};